var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"indecisive-btn",attrs:{"to":"/restaurant/random"}},[_c('span',[_vm._v(" 🤯 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }